<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  watch:{
    '$route' (to, from) {
      if (to.name !== 'question' && this.isClient) {
        window.SSAICSDK.business.draft.hideDraft();
      }
    }
  },
  computed: {
    isClient() { // 是否是客户端
      return window.SSAICSDK && window.SSAICSDK.business && window.SSAICSDK.business.draft;
    },
  },
  mounted() {
    const outerWidth = window.screen.width;
    console.log(outerWidth);
    window.onpopstate = () => {
      window.history.go(-1)
    }
  }
};
</script>

<style  lang="scss">
@import "./styles/index";
@import "./styles/reset";
@import "./styles/global";
@import "./styles/element";
[v-cloak] {
  display: none;
}
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  img {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue